<template>
  <Authentication
    auth-type="signup"
    :auth-methods="loginMethods"
    @on-login-or-sign-up-google-user="singupGoogle"
    @on-registern-email-user="register($event)"
  />
</template>

<script lang="ts" setup>
import { useHead } from '@unhead/vue'
import { useNotification } from '@kyvg/vue3-notification'
import Authentication from '@/components/AuthenticationForm.vue'
import { useAuth } from '@/composables/useAuth'
import { useRouter } from 'vue-router'
import { AuthService } from '@/services/AuthService'

useHead({ title: 'Signup' })

const { loginOrSignUpGoogle, registerEmailUser } = useAuth()
const { notify } = useNotification()
const loginMethods = ['email', 'google']
const router = useRouter()
const authService = new AuthService()

const singupGoogle = async  () => {
  await loginOrSignUpGoogle().catch((error) => {
    notify({ type: 'error', title: 'Error', text: error.message || 'An error occurred while trying to login' })
  })
}

const errorMap = {
  'auth/email-already-in-use': 'Email already in use, please click link below to login',
  'auth/invalid-email': 'Invalid email',
  'auth/weak-password': 'Weak password',
  'auth/operation-not-allowed': 'Operation not allowed',
  'auth/user-not-found': 'User not found',
}

const register = async (data: {email: string, password: string, name: string}) => {
  try {
    await registerEmailUser(data.email, data.password, data.name)
    // Send verification email
    const redirectURL = `${window.location.protocol}//${window.location.host}/email-action-handler`
    await authService.sendVerificationEmail(data.email, redirectURL)
    // Redirect to dashboard
    router.push('/')
  } catch (error) {
    const errorMessage = errorMap[error.code] || 'An error occurred while trying to register'
    notify({ type: 'error', title: 'Error', text: errorMessage })
  }
}
</script>
